import type { RouterConfig } from '@nuxt/schema'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useLenisStore } from '~/stores/LenisStore'

export default {
  scrollBehavior(to, from, savedPosition) {
    const nuxtApp = useNuxtApp()
    const store = useLenisStore()
    const DELAY = 800

    if (to.path === from.path) {
      return new Promise(() => {
        store.lenis?.scrollTo(
          to.hash ? (document.querySelector(to.hash) as HTMLElement)?.offsetTop : 0
        )
      })
    } else if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ el: to.hash })
          store.lenis?.scrollTo(to.hash, {
            onComplete: () => {
              ScrollTrigger.refresh()
            }
          })
        }, DELAY)
      })
    } else if (savedPosition) {
      return new Promise((resolve) => {
        nuxtApp.hooks.hookOnce('page:finish', () => {
          setTimeout(() => {
            resolve(savedPosition)
            store.lenis?.scrollTo(Number(savedPosition), {
              immediate: true,
              onComplete: () => {
                ScrollTrigger.refresh()
              }
            })
          }, DELAY)
        })
      })
    } else {
      return new Promise((resolve) => {
        nuxtApp.hooks.hookOnce('page:finish', () => {
          setTimeout(() => {
            resolve({ top: 0 })
            store.lenis?.scrollTo(0, {
              immediate: true,
              onComplete: () => {
                ScrollTrigger.refresh()
              }
            })
          }, DELAY)
        })
      })
    }
  }
} satisfies RouterConfig
